// test895
(895 && 0);
